import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { FikoYTKokBilesenComponent } from '../../../../kok-bilesen/kok-bilesen.component';
import { RouterLink, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BildirimService, IBildirim } from '../../../../servisler/bildirim.service';
import { BildirimTercihleriService } from '../../../../servisler/bildirim-tercihleri.service';
import { TemaService } from '../../../../servisler/tema.service';


@Component({
  selector: 'fikoyt-diyalog-kullanici-menu',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule, RouterModule, RouterLink],
  templateUrl: "./fikoyt-diyalog-kullanici-menu.component.html",
  styleUrl: "./fikoyt-diyalog-kullanici-menu.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FikoYTDiyalogKullaniciMenuComponent extends FikoYTKokBilesenComponent {

  aktifSekme: 'profil' | 'bildirimler' | 'ayarlar' = 'profil';

  get superYoneticiMi(): boolean {
    const k = this.FikoYT.kimlik.aktifKullaniciJson();
    const yetkiler: string[] = k?.yetkiler || k?.veri?.yetkiler || [];
    return yetkiler.some(y => y === 'Süper Yönetici' || y === 'Super Yonetici');
  }
  bildirimSvc = inject(BildirimService);
  tercihSvc = inject(BildirimTercihleriService);
  temaSvc = inject(TemaService);
  olayTipleri = [
    { olay: 'kart_olusturuldu', etiket: 'Kart oluşturuldu' },
    { olay: 'kart_guncellendi', etiket: 'Kart güncellendi' },
    { olay: 'alt_kart_eklendi', etiket: 'Alt kart eklendi' },
    { olay: 'yorum_eklendi', etiket: 'Yorum eklendi' },
    { olay: 'atandi', etiket: 'Atandı' },
    { olay: 'kart_silindi', etiket: 'Kart silindi' },
    { olay: 'bahsedildi', etiket: 'Bahsedildi' },
  ];
  ayarlar = {
    kompaktYazi: false,
    cevrimichiDurum: true,
    profilHerkesGorsun: true,
  };

  form: any = { "desktop": 0, "machine": 0, "mobile": 0, "tablet": 0, "tv": 0 };

  get toplamOturum(): number {
    const c = this.FikoYT.kimlik.cihazlar();
    return (c.desktop || 0) + (c.mobile || 0) + (c.tablet || 0) + (c.machine || 0);
  }

  constructor() {
    super();
  }

  tiklandiCikisYap() {
    this.FikoYT.kimlik.cikisYap().then(() => {
      this.CD.detectChanges();
    })
  }

  bildirimTiklandi(b: IBildirim) {
    if (!b.okudu) this.bildirimSvc.okunduIsaretle(b._id!);
    if (b.kartId) this.router.navigate(['/\u{1F3E0}/\u{1F468}/\u{1F6A8}']);
  }

  zamanOnce(tarih: string): string {
    return BildirimService.zamanOnce(tarih);
  }

  olayTercihDegistir(olay: string, aktif: boolean) {
    this.tercihSvc.olayTercihKaydet(olay, aktif);
  }
}
